enum AccountTypeEnum {
    IncomeTrust = 'INCOME_TRUST',
    Marketplace = 'MARKETPLACE',
}

export default AccountTypeEnum;